<template>
  <div class="login-container">
    <transition name="fade">
      <div v-show="show">
        <div class="spinner-containe big logout-text">
          <small>Thanks for using</small>
          <br>
          <big>SoundSys</big>
          <small>backoffice</small>
        </div>

        <a
          class="btn -btn-primary logout-text-link"
          href="/"
        >Go back to login</a>

        <img
          class="logout-logo"
          src="../../../assets/img/soundsys_white_big.resized.png"
        >
        <img
          class="logout-bg"
          src="../../../assets/img/preview.jpg"
        >
      </div>
    </transition>
  </div>
</template>

<style scoped>
.logout-logo {
  top: 0;
  position: fixed;
  width: 50vw;
  opacity: 0.1;
  left: 0;
}

.logout-text {
  font-size: 3em;
}

.logout-text-link {
  font-size: 1.2em;
  z-index: 30;
  position: fixed;
  bottom: 20%;
}

.logout-text-link:hover {
  font-size: 1.4em;
}

.logout-bg {
  top: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  opacity: 0.5;
  right: 0;
}

img.logout-bg {
  -webkit-mask-image:
    -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(0, 0, 0, 1)),
      to(rgba(0, 0, 0, 0))
    );
  mask-image: linear-gradient(to left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
}
</style>

<script>
export default {
  name: "Logout",
  data () {
    return { show: false }
  },
  mounted () {
    localStorage.removeItem("userRole")
    localStorage.removeItem("lang")
    localStorage.removeItem("claimList")
    this.$router.push({ name: "welcome" })
    setTimeout(this.loaded, 500)
  },
  methods: {
    loaded () {
      this.show = true
    }
  }
}
</script>

